import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import UserInfo from "./components/RoomHeader/UserInfo/index.mjs";
import RoomControl from "./components/RoomHome/RoomControl/index.mjs";
import LanguageIcon from "./components/common/Language.vue.mjs";
import SwitchTheme from "./components/common/SwitchTheme.vue.mjs";
import "./services/main.mjs";
import { roomService } from "./services/roomService.mjs";
import { EventType } from "./services/types.mjs";
import "./locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import { isMobile } from "./utils/environment.mjs";
import "mitt";
import "./services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import ScheduleRoomList from "./components/ScheduleConference/ScheduleRoomList.vue.mjs";
import Logo from "./components/common/Logo.vue.mjs";
import MessageBox from "./components/common/base/MessageBox/index.mjs";
import renderMsg from "./components/common/base/Message/Message.mjs";
import InvitationNotification from "./components/RoomInvite/InvitationNotification.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "preConference",
  props: {
    userInfo: { default: () => ({
      userId: "",
      userName: "",
      avatarUrl: ""
    }) },
    showEditNameInPc: { type: Boolean, default: false },
    roomId: { default: "" },
    enableScheduledConference: { type: Boolean, default: true },
    isShowLogo: { type: Boolean, default: true },
    isShowHeaderInfo: { type: Boolean, default: true }
  },
  emits: [
    "on-create-room",
    "on-enter-room",
    "on-update-user-name",
    "on-logout"
  ],
  setup(__props, { emit: emits }) {
    const props = __props;
    const roomControlRef = ref();
    const tuiRoomThemeClass = computed(
      () => `tui-theme-${roomService.basicStore.defaultTheme}`
    );
    async function handleCreateRoom(roomOption) {
      emits("on-create-room", roomOption);
    }
    async function handleEnterRoom(roomOption) {
      emits("on-enter-room", roomOption);
    }
    function handleUpdateUserName(userName) {
      emits("on-update-user-name", userName);
    }
    async function handleLogOut() {
      emits("on-logout");
    }
    const showMessageBox = (data) => {
      const {
        message,
        title = roomService.t("Note"),
        duration,
        cancelButtonText,
        confirmButtonText = roomService.t("Sure"),
        callback = () => {
        }
      } = data;
      MessageBox({
        title,
        message,
        duration,
        cancelButtonText,
        confirmButtonText,
        callback
      });
    };
    const showMessage = (data) => {
      const { type, message, duration } = data;
      renderMsg({
        type,
        message,
        duration
      });
    };
    onMounted(() => {
      roomService.on(EventType.ROOM_NOTICE_MESSAGE, showMessage);
      roomService.on(EventType.ROOM_NOTICE_MESSAGE_BOX, showMessageBox);
    });
    onUnmounted(() => {
      roomService.off(EventType.ROOM_NOTICE_MESSAGE, showMessage);
      roomService.off(EventType.ROOM_NOTICE_MESSAGE_BOX, showMessageBox);
    });
    return { __sfc: true, roomControlRef, props, emits, tuiRoomThemeClass, handleCreateRoom, handleEnterRoom, handleUpdateUserName, handleLogOut, showMessageBox, showMessage, UserInfo, RoomHomeControl: RoomControl, LanguageIcon, SwitchTheme, ScheduleRoomList, Logo, isMobile, InvitationNotification };
  }
});
export {
  _sfc_main as default
};
